import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-file-upload-drag-drop',
    templateUrl: './file-upload-drag-drop.component.html',
    styleUrls: ['./file-upload-drag-drop.component.scss'],
    standalone: false
})
export class FileUploadDragDropComponent {
  @Input() infoText = 'Drag and drop or upload file';
  @Input() btnText = 'Upload file';
  @Output() emitFile: EventEmitter<File> = new EventEmitter<File>();

  isDragOver = false;
  fileName: string;

  handleFileDrop(event: FileList | Event): void {
    if (event instanceof FileList) {
      if (event.length === 0) return;
      const file = event[0];
      this.emitFile.emit(file);
      this.fileName = file.name;
    } else {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        this.emitFile.emit(target.files[0]);
        this.fileName = target.files[0].name;
      }
    }
  }
}
